import { useTranslations } from 'next-intl';
import type { ComponentPropsWithoutRef, MouseEventHandler } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import { EventType } from '@/analytics/types';
import LandingPageCards from '@/app/components/LandingPage/LandingPageCards';

const IntegrationsAppCards = (): JSX.Element => {
  const t = useTranslations();
  const handleCardLinkClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    const { href } = event.currentTarget;
    void window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'read more',
      location: 'body',
      path: href,
    });
  };
  const baseCardCtaData: {
    label: MessageKey;
    onClick: MouseEventHandler<HTMLAnchorElement>;
    target: ComponentPropsWithoutRef<'a'>['target'];
  } = {
    label: 'integrations_card_read_more',
    onClick: handleCardLinkClick,
    target: '_blank',
  };

  return (
    <div className="py-20">
      <LandingPageCards
        cards={[
          {
            description: 'integrations_headspace_description',
            id: 'headspace',
            image: {
              localizedAlt: 'integrations_headspace_card_img_alt',
              src: '/blue-sky/integrations/headspace-card.png',
            },
            link: {
              ...baseCardCtaData,
              href: 'https://ouraring.com/blog/oura-headspace-partnership/',
              values: {
                appName: t('integrations_app_name_headspace'),
              },
            },
            title: 'integrations_app_name_headspace',
          },
          {
            description: 'integrations_strava_description',
            id: 'strava',
            image: {
              localizedAlt: 'integrations_strava_card_img_alt',
              src: '/blue-sky/integrations/strava-card.png',
            },
            link: {
              ...baseCardCtaData,
              href: 'https://ouraring.com/blog/oura-and-strava-partnership/',
              values: {
                appName: t('integrations_app_name_strava'),
              },
            },
            title: 'integrations_app_name_strava',
          },
          {
            description: 'integrations_natural_cycles_description',
            id: 'natural_cycles',
            image: {
              localizedAlt: 'integrations_natural_cycles_card_img_alt',
              src: '/blue-sky/integrations/natural-cycles-card.png',
            },
            link: {
              ...baseCardCtaData,
              href: 'https://ouraring.com/blog/oura-partners-with-fda-cleared-birth-control-app-natural-cycles/',
              values: {
                appName: t('integrations_app_name_natural_cycles'),
              },
            },
            title: 'integrations_app_name_natural_cycles',
          },
        ]}
      />
    </div>
  );
};

export default IntegrationsAppCards;
